export default [
    {
        "id": "registration",
        "html": require('./registration/html').default,
        "css": require('./registration/css').default,
        "cssMobile": require('./registration/cssMobile').default,
        "scss": require('./registration/scss').default,
        "scssMobile": require('./registration/scssMobile').default,
        "js": require('./registration/js').default,
        "minJs": require('./registration/minJs').default,
        "pages": 'Registration'
    }
]